import '../styles/global.css';
import '../../com-ui2/styles/index.scss'
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import App, { AppProps } from 'next/app'
import Router /*,{ useRouter }*/ from 'next/router'
import { /*privateRouters,*/ withAuth, withRedux } from 'com-ui/hocs'
import { AdminLayout } from '@/shared/containers/AdminLayout'
import NProgress from 'nprogress' //nprogress module
import { useEffect, useRef, useState } from 'react'
import { useIcons } from 'com-ui/layouts/selless.theme'
import { withToast } from 'com-ui2/utilities'
import getConfig from 'next/config'
import { getCookie } from 'cookies-next/lib'
import { appWithTranslation } from 'next-i18next'
import { AccountService } from '@/shared/services';
import { useDispatch } from 'react-redux';
import { setUserInfo } from '@/shared/stores'
if (!process.browser) {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const React = require('react')
  React.useLayoutEffect = React.useEffect //prevent framer-motion using useLayoutEffect on SSR
}

// const isDev = process.env.NODE_ENV != 'production'
// Register Sentry
// !isDev && initSentry()

// Show progress bar on switching route
NProgress.configure({ showSpinner: false })
Router.events.on('routeChangeStart', () => NProgress.start())
Router.events.on('routeChangeComplete', () => NProgress.done())
Router.events.on('routeChangeError', () => NProgress.done())

// @ts-ignore
function MyApp({ Component, pageProps, err }: AppProps) {
  const dispatch = useDispatch()
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    useIcons()
    const accessToken = getCookie('access-token')?.toString();
    if(accessToken && accessToken != '') {
      AccountService.getAccountInfo().then((res: any) => {
        if(res['code'] == 0) {
          dispatch(setUserInfo(res['data']))
        }
      })
      setIsLoggedIn(true);
    }
  }, [])

  return !isLoggedIn ? (
    <Component {...pageProps} err={err} />
  ) : (
    <AdminLayout>
      <Component {...pageProps} err={err} />
    </AdminLayout>
  )
}

MyApp.getInitialProps = async (ctx: any) => {
  const appProps = App.getInitialProps && (await App.getInitialProps(ctx))

  return appProps
}

const jwt = getConfig().publicRuntimeConfig.jwtCookieKey
export default withRedux(withToast(withAuth(appWithTranslation(MyApp), { location: '/login', jwtCookieKey: jwt })))
